
import { ValidationProvider } from 'vee-validate'

export default {
  components: { ValidationProvider },
  props: {
    radioValue: { required: true, type: String },
    id: { required: true, type: String },
    name: { required: true, type: String },
    class_: { required: false, default: 'custom-control-input', type: String },
    rules: { required: false, default: null }
  }
}
